import { useConfirmDialog } from '../../../hooks/utils/useConfirmDialog';
import { ICommentState, useCommentsState } from './useCommentsState';
import { CommentCardEdit } from './CommentCardEdit';
import { CommentCardView } from './CommentCardView';

export function CommentView({
  comment,
  commentsState,
}: {
  comment: ICommentState;
  commentsState: ReturnType<typeof useCommentsState>;
}) {
  const deleteComment = (comment: ICommentState) => {
    confirm({
      message:
        'Are you sure you want to delete this comment? There is no going back.',
      confirmText: 'Delete',
      cancelText: 'Cancel',
      confirmCallback: () => commentsState.removeComment(comment),
    });
  };
  const { confirm } = useConfirmDialog();
  if (comment.isEditing) {
    return (
      <CommentCardEdit
        key={comment.key}
        comment={comment.edit}
        setComment={commentsState.editComment(comment)}
        saveComment={() => commentsState.saveComment(comment)}
        cancelComment={() => commentsState.cancelComment(comment)}
      />
    );
  }

  if (comment.original !== null) {
    return (
      <CommentCardView
        key={comment.original.ID}
        comment={comment.original}
        setEditComment={() => commentsState.setEditComment(comment)}
        removeComment={() => deleteComment(comment)}
        markAsResolved={() => commentsState.markAsResolved(comment)}
      />
    );
  }

  return null;
}
